import { render, staticRenderFns } from "./ShownColumnsRow.vue?vue&type=template&id=1636f87e&scoped=true&"
import script from "./ShownColumnsRow.vue?vue&type=script&lang=js&"
export * from "./ShownColumnsRow.vue?vue&type=script&lang=js&"
import style0 from "./ShownColumnsRow.vue?vue&type=style&index=0&id=1636f87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1636f87e",
  null
  
)

export default component.exports